<template>
  <div id="group-selector" v-click-outside="closeGroupSelector">
    <div class="gs">
      <div class="selector-holder">
        <div class="pointer">
          <h2>Group Selected</h2>
        </div>
        <div class="selector-box">
          <div class="subselector-box">
            <SubSelector
              v-for="(tab) in tabs"
              :key="tab"
              :label="camelToTitle(tab)"
              :tab="tab"
              @activate-tab="onTabActivate"
            />
          </div>
          <div
            v-if="hasSelection && !userHasTripleOnes"
            class="clear"
          >
            <a
              @click.stop="onClearSelection"
              href="javascript:void(0)"
            >
              Clear
            </a>
          </div>
        </div>
      </div>
      <GroupSelectorSearch
        @activate-tab="onTabActivate"
        @item-select="onItemSelect"
        :isVisible="showSearch"
      />
    </div>
  </div>
</template>

<script>
import { computed, onBeforeMount, ref } from '@vue/composition-api';
import GroupSelectorSearch from '@organisms/v2/GroupSelectorSearch.vue';
import SubSelector from '@molecules/v2/GroupSelector/SubSelector.vue';
import { camelToSnakeCaps, camelToTitle } from '@utils';
import { useStore } from '@vue3shims';

export default {
  setup() {
    const currentSelection = computed(() => store.getters['groupSelector/selected']);
    const currentTab = computed(() => store.getters['groupSelector/currentTab']);
    const hasSelection = computed(() => store.getters['groupSelector/hasSelection']);
    const showSearch = computed(() => store.getters['groupSelector/showSearch']);
    const store = useStore();
    const setter = computed(() => `SET_${camelToSnakeCaps(currentTab.value)}`);
    const tabs = computed(() => {
      let tabs = store.getters['groupSelector/tabs'] || [];
      let userHasOneParent = store.getters['groupSelector/userHasOneParent'];
      if(userHasOneParent) {
        return tabs.filter(tab => tab !== 'parentGroup');
      }
      return tabs;
    });

    const userHasTripleOnes = computed(() => store.getters['groupSelector/userHasTripleOnes']);
    const onClearSelection = () => {
      store.dispatch('groupSelector/CLEAR_SELECTION');
    }

    const onItemSelect = (item) => {
      let selected = Object.assign({}, {type: currentTab.value, [`${currentTab.value}Ck`]: item[`${currentTab.value}Ck`]});
      // don't set if they are picking what's already selected
      if(selected.parentGroupCk !== currentSelection.value.parentGroupCk
      || selected.groupCk !== currentSelection.value.groupCk
      || selected.subGroupCk !== currentSelection.value.subGroupCk) {
        // console.log(`selected`, selected);
        store.dispatch(`groupSelector/SET_SELECTED`, selected);
      }
      // store.commit(`groupSelector/${setter.value}`, item);
      store.commit('groupSelector/CLEAR_SHOW_SEARCH');
      // console.log(`hasSelection`, hasSelection.value);
    }

    const onTabActivate = (tab) => {
      // console.log(`tab: ${tab}, current: ${currentTab.value}, show: ${showSearch.value}`);
      if(!(tab === currentTab.value && showSearch.value === true)) {
        store.commit('groupSelector/SET_SHOW_SEARCH', true);
        store.commit('groupSelector/SET_CURRENT_TAB', tab);
        store.commit('groupSelector/CLEAR_SEARCH');
      }
    }

    const closeGroupSelector = () => {
      store.commit('groupSelector/SET_SHOW_SEARCH', false);
    }

    // onBeforeMount(() => {
    //   console.log(store.getters['groupSelector/selected']);
    // });

    return {
      camelToTitle,
      closeGroupSelector,
      hasSelection,
      onClearSelection,
      onItemSelect,
      onTabActivate,
      showSearch,
      tabs,
      userHasTripleOnes,
    }
  },
  components: {
    GroupSelectorSearch,
    SubSelector,
  }
}
</script>

<style lang="scss" scoped>
#group-selector {
  background: $leaf;
  color: $white;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .gs {
    display: flex;
    flex-direction: column;
    width: 100%;

    .selector-holder {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      .selector-box {
        display: flex;
        justify-content: space-between;
        width: 100%;

        .clear {
          padding: 0 2rem;
          a {
            color: $white;
            font-size: 0.85rem;
            font-weight: bold;
            text-decoration: underline;
            cursor: pointer;
          }
        }
        .subselector-box {
          display: flex;
          justify-content: space-evenly;
          align-items: center;
        }
      }

      .pointer {
        width: 16rem;
        height: 50px; 
        position: relative;
        background: $color-leaf-bg;
        padding-right: 2rem;
        padding-left: 5rem;

        h2 {
          background: $color-leaf-bg;
          height: 50px;
          color: #fff;
          margin: 0;
          padding: 12px 0;
          font-family: "Nexa Bold", "Helvetica", sans-serif;
          font-size: 19px;
          font-size: 1.35714rem;
          white-space: nowrap;
        }
      }

      .pointer:before {
        content: "";
        position: absolute;
        right: -25px;
        bottom: 0;
        width: 0;
        height: 0;
        border-left: 25px solid $color-leaf-bg;
        border-top: 25px solid transparent;
        border-bottom: 25px solid transparent;
      }
    }
  }
}
</style>
